<template>
  <v-container class="device-connection">
    <FormRow
      v-if="deviceMapRules[deviceModel][version]['APN']"
      label="Cellular APN"
      :input-payload="APN"
      @parseNewVAl="parseNewVal($event, 'APN', 'Connection / Cellular APN')"
    />
    <FormRow
      v-if="deviceMapRules[deviceModel][version]['NAO']"
      label="Network Access Order"
      :input-payload="NAO"
      :dropdown="true"
      :options="NAOMap"
      @parseNewVAl="parseNewVal($event, 'NAO', 'Connection / Network Access Order')"
    />
    <FormRow
      v-if="deviceMapRules[deviceModel][version]['auth']"
      label="Authentication Methods"
      :input-payload="auth"
      :dropdown="true"
      :options="authMap"
      @parseNewVAl="updateAuthType"
    />
    <FormRow
      v-if="deviceMapRules[deviceModel][version]['username']"
      label="Username"
      :input-payload="username"
      :is-disabled="!enabledUsername"
      :rules="usernameRules"
      @parseNewVAl="parseNewVal($event, 'username', 'Connection / Username')"
    />
    <FormRow
      v-if="deviceMapRules[deviceModel][version]['password']"
      label="Password"
      :input-payload="password"
      :is-disabled="!enablePassword"
      :rules="passwordRules"
      @parseNewVAl="parseNewVal($event, 'password', 'Connection / Password')"
    />
    <FormRow
      v-if="deviceMapRules[deviceModel][version]['service']"
      label="Service"
      :input-payload="service"
      :dropdown="true"
      :options="serviceMap"
      @parseNewVAl="parseNewVal($event, 'service', 'Connection / Service')"
    />
    <FormRow
      label="Installation Tag"
      :input-payload="vehicleName"
      :static-field="true"
    />
  </v-container>
</template>

<script>

import FormRow from '../components/FormRow.vue';

import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';


// import { Logger } from "aws-amplify";
// const logger = new Logger("App");

export default {
  name: 'Connection',
  components: {
    FormRow
  },
  mixins: [deviceConfigMixin],
  props: {
    config: {
      type: Object,
      required: true
    },
    vehicleName: {
      type: String,
      required: true
    },
    deviceModel: {
      type: String,
      required: true
    },
    version: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      NAOMap: [
        {
          xml: 'auto',
          label: 'Auto'
        },
        {
          xml: 'lte',
          label: 'LTE'
        },
        {
          xml: 'gsm',
          label: 'GSM'
        },
        {
          xml: 'wcdma',
          label: 'WCDMA'
        },
        {
          xml: 'lte_wcdma_gsm',
          label: 'LTE, WCDMA, GSM'
        }
      ],
      authMap: [
        {
          xml: 'none',
          label: 'None'
        },
        {
          xml: 'pap',
          label: 'PAP'
        },
        {
          xml: 'chap',
          label: 'CHAP'
        },
        {
          xml: 'pap_chap',
          label: 'PAP/CHAP'
        }
      ],
      serviceMap: [
        {
          xml: 'cameramatics_1',
          label: 'Cameramatics Prod'
        }
      ],
      authMethod: '',
      enabledUsername: false,
      enablePassword: false,
      deviceMapRules: {
        'CAMERAMATICS_D700-SD-4G': {
          '1.0.0': {
            'APN': false,
            'NAO': false,
            'auth': false,
            'username': false,
            'password': false,
            'service': true
          },
          '1.0.1': {
            'APN': true,
            'NAO': true,
            'auth': false,
            'username': false,
            'password': false,
            'service': true
          }
        },
        'CAMERAMATICS_JH4-HD-4G': {
          '1.0.0': {
            'APN': true,
            'NAO': true,
            'auth': true,
            'username': true,
            'password': true,
            'service': true
          },
          '1.0.1': {
            'APN': true,
            'NAO': true,
            'auth': true,
            'username': true,
            'password': true,
            'service': true
          }
        },
        'CAMERAMATICS_JH8-HD-4G': {
          '1.0.0': {
            'APN': true,
            'NAO': true,
            'auth': true,
            'username': true,
            'password': true,
            'service': true
          },
          '1.0.1': {
            'APN': true,
            'NAO': true,
            'auth': true,
            'username': true,
            'password': true,
            'service': true
          }
        },
        'CAMERAMATICS_JH4_NT-HD-4G': {
          '1.0.0': {
            'APN': true,
            'NAO': true,
            'auth': true,
            'username': true,
            'password': true,
            'service': true
          },
          '1.0.1': {
            'APN': true,
            'NAO': true,
            'auth': true,
            'username': true,
            'password': true,
            'service': true
          }
        },
        'CAMERAMATICS_JH8_NT-HD-4G': {
          '1.0.0': {
            'APN': true,
            'NAO': true,
            'auth': true,
            'username': true,
            'password': true,
            'service': true
          },
          '1.0.1': {
            'APN': true,
            'NAO': true,
            'auth': true,
            'username': true,
            'password': true,
            'service': true
          }
        },
        'CAMERAMATICS_JI7A-SD-4G': {
          '1.0.0': {
            'APN': true,
            'NAO': true,
            'auth': true,
            'username': true,
            'password': true,
            'service': true
          },
        }
      }
    }
  },
  computed: {
    APN() {
      return this.config.device_config.connectivity[0].cellular[0].apn[0].name[0];
    },
    NAO() {
      return this.config.device_config.connectivity[0].cellular[0].networkAccessOrder[0];
    },
    auth() {
      if (this.deviceModel === 'CAMERAMATICS_JH4-HD-4G') {
        return this.config.device_config.connectivity[0].cellular[0].apn[0].auth[0].method[0];
      }
      else {
        return false;
      }
    },
    username() {
      return this.config.device_config.connectivity[0].cellular[0].apn[0].auth[0].user[0];
    },
    password() {
      return this.config.device_config.connectivity[0].cellular[0].apn[0].auth[0].password[0];
    },
    isDisabled() {
      let auth = this.config.device_config.connectivity[0].cellular[0].apn[0].auth[0].method[0];

      return auth === 'none' ? true : false;
    },
    service() {
      return this.config.device_config.connectivity[0].selectedService[0];
    },
    passwordRules() {
      return [];
    },
    usernameRules() {
       return [];
    },
    mapList() {
      const list = [this.NAOMap, this.authMap, this.serviceMap];

      return list.flat();
    }
  },
  watch: {
    authMethod() {
      if (this.authMethod === 'pap' || this.authMethod === 'pap_chap') {
        //  username and password fields are required
        this.enabledUsername = true;
        this.enablePassword = true;
      } 
      else if (this.authMethod === 'chap') {
        // Only password is required
        this.enabledUsername = false;
        this.enablePassword = true;
      } 
      else {
        this.enabledUsername = false;
        this.enablePassword = false;
      }
    }
  },
  mounted() {
    this.mapAuthType();
  },
  methods: {
    updateAuthType(val) {
      let map = this.authMap.find(item => {
        return item.label === val;
      });

      this.authMethod = map.xml;
      this.parseNewVal(val, 'auth', 'Connection / Authenitication Methods');
    },
    mapAuthType() {
      this.authMethod = this.auth;
    },
    parseNewVal(val, id, label) {
      let payload = {
        newValue: this.returnMappedVal(val, [this.NAOMap, this.authMap, this.serviceMap]),
        key: this.configPropMapper(id),
        label: label
      }

      this.$emit('settingsUpdated', payload, this.mapList);
    },
    configPropMapper(key) {
      let map = {
        'APN': 'device_config.connectivity[0].cellular[0].apn[0].name[0]',
        'NAO': 'device_config.connectivity[0].cellular[0].networkAccessOrder[0]',
        'auth': 'device_config.connectivity[0].cellular[0].apn[0].auth[0].method[0]',
        'username': 'device_config.connectivity[0].cellular[0].apn[0].auth[0].user[0]',
        'password': 'device_config.connectivity[0].cellular[0].apn[0].auth[0].password[0]',
        'isDisabled': 'device_config.connectivity[0].cellular[0].apn[0].auth[0].method[0]',
        'service': 'device_config.connectivity[0].selectedService[0]'
      }

      return map[key];
    }
  }
}
</script>